import { Injectable } from '@angular/core';

@Injectable()
export class KeyCodeService {
  constructor() {}
  isValid(key: KeyboardEvent): boolean {
    if (key.keyCode >= 48 && key.keyCode <= 57) {
      // for numbers
      return true;
    }
    if (key.keyCode >= 65 && key.keyCode <= 90) {
      // for alfa
      return true;
    }
    if (key.keyCode >= 96 && key.keyCode <= 105) {
      // for Numerals pad
      return true;
    }
    if (this.isCodeBackspaceOrSpace(key)) {
      return true;
    }
    return false;
  }

  isCodeBackspaceOrSpace(key: KeyboardEvent): boolean {
    if (key.keyCode === 8 || key.keyCode === 32) {
      // 8 - for backspace | 32 - for space
      return true;
    }
  }

  isEnterKey(key: KeyboardEvent): boolean {
    return key.keyCode === 13;
  }

  isSpecialKey(keyCode: number): boolean {
    if (
      (keyCode >= 9 && keyCode <= 27) ||
      (keyCode >= 33 && keyCode <= 46) ||
      (keyCode >= 91 && keyCode <= 93) ||
      keyCode >= 106
    ) {
      return true;
    }
    return false;
  }
  isSpaceKey(keyCode: number): boolean {
    return keyCode === 32;
  }
}
